import React from 'react';

import {
  ThemedCalendar,
  ThemedCalendarDay,
  ThemedCalendarMonth,
} from '../../themes';
import { noop } from '../../utils';


const CalendarMonth = ({ name, datesLength }) => {
  return (
    <ThemedCalendarMonth name={ name } datesLength={ datesLength } />
  );
};

const CalendarDay = ({ isWeekend, isCurrent, isActive, dayInitial, date, onClick }) => {
  return (
    <ThemedCalendarDay
      date={ date }
      isWeekend={ isWeekend }
      isActive={ isActive }
      isCurrent={ isCurrent }
      dayInitial={ dayInitial }
      onClick={ onClick }
    />
  );
};

const Calendar = ({ calendar, currentDate, activeDates, setDate }) => {
  const months = (
    calendar.months.map(month => (
      <CalendarMonth key={ month.value } name={ month.name } datesLength={ month.datesLength } />
    ))
  );
  const days = (
    calendar.dates.map(day => {
      const isActive = activeDates.includes(day);
      const isCurrent = day.equals(currentDate);
      const onClick = isActive ? () => setDate(day) : noop;
      return (
        <CalendarDay
          key={ day.format() }
          date={ day.date }
          isWeekend={ day.isWeekend }
          isActive={ isActive }
          isCurrent={ isCurrent }
          dayInitial={ day.dayInitial }
          onClick={ onClick }
        />
      );
    })
  );
  return (
    <ThemedCalendar months={ months } days={ days } datesLength={ calendar.datesLength } />
  );
};

export default Calendar;
